<div class="cont-combobox-mas-label col-12" bind:this={componenteRef}>
      <div class="parte-combo-siempre-visible cont-combo">
            <!-- 2 - REAL COMBO-BOX: -->

            <!-- <div class="bsr"> -->
            <input
                  type="text"
                  class="form-control real-combo"
                  name="real-combo-{idRandom}"
                  id="real-combo-{idRandom}"
                  on:click={abrirCombo}
                  on:input={buscar}
                  on:keydown={manejarTeclas}
                  bind:value={selectedNOTNull}
            />
            <!-- </div> -->
            <!-- 1 - LABEL: -->
            <label
                  class="label-input pointer {comboAbierto || value != null ? 'floated' : ''}"
                  for="real-combo-{idRandom}"
                  on:click={abrirCombo}
                  on:keypress={abrirCombo}
            >
                  {texto}
            </label>

            <!-- 2 - IMG OPCION SELECTED: -->
            <div
                  class="img-selected BSR divImgCenter"
                  style="background-image:url('{value?.foto?.full}')"
            ></div>

            <!-- 3 - CRUZ DE UNSELECT:-->
            <div class="cont-cruz-unselect flex-center-h flex-center-v">
                  {#if selectedNOTNull}
                        <IconoNico
                              name="cross"
                              color="grey"
                              clases="pointer"
                              fnClick={() => unselect()}
                        />
                  {:else if !comboAbierto}
                        <IconoNico
                              name="chevron-down"
                              color="grey"
                              clases="pointer"
                              fnClick={() => abrirCombo()}
                        />
                  {:else}
                        <IconoNico
                              name="chevron-up"
                              color="grey"
                              clases="pointer"
                              fnClick={() => closeCombo()}
                        />
                  {/if}
            </div>
      </div>

      {#if comboAbierto}
            <!-- 2 - PARTE NO VISIBLE DEL COMBO BOX EN UN PRINCIPIO:-->
            <div
                  class="contenedor-material-oculto-combo-box-parte-no-visible-inicio"
                  style="padding-left: 40px;
                  padding-right: 20px;"
                  on:keydown={manejarTeclas}
            >
                  <!-- 99 - LISTADO DE OPCIONES SELECCIONABLES:-->
                  <div
                        class="cont-opciones bsg"
                        bind:this={opcionesRef}
                        style="max-height:{maxHOpciones};"
                  >
                        {#each arrFiltered as opcionLoop, index}
                              <div
                                    class="opcion-item pointer flex {index === posFlechas
                                          ? 'opcion-item-selected'
                                          : ''}"
                                    on:click={() => selectOpcion(index)}
                                    on:keypress={() => selectOpcion(index)}
                              >
                                    <!-- style="background-color: red;" -->
                                    <div
                                          class="cont-img-option divImgCenter"
                                          style="background-image: url('{opcionLoop?.foto?.full}')"
                                    ></div>
                                    {#if debug}
                                          {index} -
                                    {/if}
                                    <div class="texto-opcion-loop flex-center-v">
                                          <!-- <img src={opcionLoop?.foto?.full} /> -->
                                          {opcionLoop?.nombre}
                                          <!-- - -->
                                          <!-- {opcionLoop?.foto?.full} -->
                                          <!-- {opcionLoop?.foto} -->
                                    </div>
                              </div>
                              <!-- {JSON.stringify(opcionLoop)} -->
                        {/each}
                  </div>
            </div>
      {/if}
      {#if debug}
            <div class="debug-combobox p-3">
                  <p>DEBUG COMBOBOX {"[" + texto + "]"}</p>
                  <p>COMBO ABIERTO: {comboAbierto}</p>
                  <p>OPCION SELECTED: {JSON.stringify(value)}</p>
                  <p>OPCION SELECTED NOT NULL: {JSON.stringify(selectedNOTNull)}</p>
                  <p>POS FLECHAS: {posFlechas}</p>
            </div>
      {/if}
</div>

<script>
      import IconoNico from "./IconoNico.svelte";
      import { onMount } from "svelte";
      export let texto = "Selecciona una opcion";
      export let busqueda = "";
      export let value = null;
      export let comboAbierto = false;
      export let debug = false;
      export let search = true;
      export let maxHOpciones = "250px";
      export let idRandom = -1;
      export let arr = [
            { id: 1, nombre: "Opcion 1" },
            { id: 2, nombre: "Opcion 2" },
            { id: 3, nombre: "Opcion 3" },
      ];
      // Agregar imágenes al array
      // $: arrConImagenes = arr.map((item) => ({
      //       ...item,
      //       foto: item.hasOwnProperty("foto") && item.foto ? item.foto : generarImagen(item.nombre),
      // }));
      $: arrConImagenes = arr.map((item) => ({
            ...item,
            foto:
                  item.hasOwnProperty("foto") && item.foto
                        ? item.foto
                        : generarImagenReadyToUse(item.nombre),
      }));
      $: selectedNOTNull = value ? value.nombre : "";
      $: arrFiltered = arrConImagenes.filter((opcion) =>
            opcion.nombre.toLowerCase().includes(busqueda.toLowerCase())
      );
      let posFlechas = -1;
      let componenteRef;
      let opcionesRef;

      onMount(() => {
            idRandom = idRandom = Math.floor(Math.random() * 100000);
            // Event listener para detectar clics fuera del componente
            document.addEventListener("click", handleOutsideClick);
      });

      function abrirCombo() {
            comboAbierto = true;
            setFocus();
      }
      function closeCombo() {
            comboAbierto = false;
      }
      function toogleCombo() {
            comboAbierto = !comboAbierto;
      }
      function buscar(event) {
            busqueda = event.target.value.toLowerCase();
            arrFiltered = arr.filter((item) => item.nombre.toLowerCase().includes(busqueda));
            comboAbierto = true;
      }
      function setFocus() {
            const inputElement = document.getElementById(`real-combo-${idRandom}`);
            if (inputElement) {
                  inputElement.focus();
            }
      }
      function handleOutsideClick(event) {
            // Si el clic ocurre fuera del contenedor, cerrar el combo
            // if (componenteRef && !componenteRef.contains(event.target)) {
            //       let targetID = event.target.id;
            //       if (targetID.indexOf("my-svg-")) {
            //             closeCombo();
            //             console.log("outside click: " + event.target.id + " > ouside");
            //       }
            // } else {
            //       console.log("outside click: " + event.target.id + " > inside");
            // }
      }

      export function selectOpcion(indexRecibido) {
            console.log(
                  "SELECCIONANDO OPCION: " + indexRecibido + " - ENTRE " + arrFiltered.length
            );
            console.log("SELECCIONANDO OPCION: " + indexRecibido);
            posFlechas = indexRecibido;

            if (indexRecibido >= 0 && indexRecibido < arrFiltered.length) {
                  const opcionSelected = arrFiltered[indexRecibido];

                  if (value != null && value.id === opcionSelected.id) {
                        value = null; // Deseleccionar si se vuelve a hacer clic en el mismo
                  } else {
                        value = opcionSelected;
                  }
            } else {
                  // Deselección en caso de índice inválido
                  value = null;
            }

            // // Cierra el combo después de un breve retraso
            // closeCombo();
            setTimeout(() => {
                  closeCombo();
            }, 50);
      }
      export function unselect() {
            posFlechas = -1;
            busqueda = "";
            selectedNOTNull = "";
            value = null;
            comboAbierto = false;
      }

      function manejarTeclas(event) {
            console.log("TECLA PRESIONADA: " + event.key);
            if (comboAbierto) {
                  const maxIndex =
                        arrFiltered.filter((opcion) =>
                              opcion.nombre.toLowerCase().includes(busqueda.toLowerCase())
                        ).length - 1;

                  console.log("MAX INDEX (TECLA PRESIONADA): " + maxIndex);
                  if (event.key === "ArrowDown") {
                        posFlechas = Math.min(posFlechas + 1, maxIndex);
                        ajustarScroll();
                        event.preventDefault();
                  } else if (event.key === "ArrowUp") {
                        posFlechas = Math.max(posFlechas - 1, 0);
                        ajustarScroll();
                        event.preventDefault();
                  } else if (event.key === "Enter") {
                        const opcionesFiltradas = arr.filter((opcion) =>
                              opcion.nombre.toLowerCase().includes(busqueda.toLowerCase())
                        );
                        selectOpcion(posFlechas);
                  } else if (event.key === "Escape") {
                        comboAbierto = false; // Cierra el combo si se presiona Escape
                        event.preventDefault();
                  }
            }
      }
      function ajustarScroll() {
            if (opcionesRef) {
                  const alturaOpcion = 50; // Altura fija por opción (ajusta según el diseño)
                  opcionesRef.scrollTop = posFlechas * alturaOpcion;
            }
      }
      // function ajustarScroll() {
      //       console.log("AJUSTANDO SCROLL");
      //       if (opcionesRef && opcionSeleccionadaRef) {
      //             const contenedor = opcionesRef;
      //             const opcion = opcionSeleccionadaRef;

      //             const contenedorTop = contenedor.scrollTop;
      //             const contenedorBottom = contenedorTop + contenedor.clientHeight;

      //             const opcionTop = opcion.offsetTop;
      //             const opcionBottom = opcionTop + opcion.clientHeight;

      //             if (opcionTop < contenedorTop) {
      //                   // Si la opción está por encima del área visible
      //                   contenedor.scrollTop = opcionTop;
      //             } else if (opcionBottom > contenedorBottom) {
      //                   // Si la opción está por debajo del área visible
      //                   contenedor.scrollTop = opcionBottom - contenedor.clientHeight;
      //             }
      //       }
      // }
      let arrColoresRandom = [
            "#596275",
            "#786fa6",
            "#cf6a87",
            "#778beb",
            "#f7d794",
            "#63cdda",
            "#38ada9",
            "#ff4d4d",
            "#0a3d62",
      ];
      let colorRandomAnt = "";

      // Función que genera la imagen con un color de fondo aleatorio desde tu lista
      function generarImagen(nombre) {
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");

            canvas.width = 100;
            canvas.height = 100;

            // Seleccionar un color aleatorio de la lista de colores
            const randomIndex = Math.floor(Math.random() * arrColoresRandom.length);
            let randomColor = arrColoresRandom[randomIndex];
            if (randomColor == colorRandomAnt) {
                  randomColor = arrColoresRandom[randomIndex];
            }
            colorRandomAnt = randomColor;

            context.fillStyle = randomColor;
            context.fillRect(0, 0, canvas.width, canvas.height);

            context.fillStyle = "white";
            context.font = "bold 50px Arial";
            // context.font = "bold 30px Arial";
            context.textAlign = "center";
            context.textBaseline = "middle";
            // const texto = nombre.substring(0, 3).toUpperCase();
            const texto = nombre.charAt(0).toUpperCase();
            // const texto = nombre.substring(0, 3).toUpperCase();
            context.fillText(texto, canvas.width / 2, canvas.height / 2);

            return canvas.toDataURL("image/jpeg");
      }
      function generarImagenReadyToUse(nombre) {
            const base64Image = generarImagen(nombre); // Llama a la función anterior para obtener el base64
            return {
                  id: -1,
                  urlOriginal: "default.jpg",
                  urlProv: "default.jpg",
                  activo: true,
                  fkinstalacion: 1,
                  full: base64Image,
                  previewDocumento: "http://localhost/payments/upload/default.jpg",
                  calcularExtension: "jpg",
            };
      }
</script>

<style>
      .cont-combobox-mas-label {
            /* border: solid 1px grey; */
            padding: 15px;
            /* border-radius: 50px; */
      }
      .cont-opciones {
            overflow-y: auto;
            overflow-x: hidden;
            border-radius: 0px 0px 6px 6px;
      }
      .cont-opciones::-webkit-scrollbar {
            width: 6px;
      }
      .cont-opciones::-webkit-scrollbar-track {
            border-radius: 50px;
            background-color: #e3e3e3;
            overflow: hidden;
      }
      .cont-opciones::-webkit-scrollbar-thumb {
            border-radius: 50px;
            background-color: #7f56da;
            overflow: hidden;
            /* background-color: rbga(0, 0, 0, 0.9); Color de la barra de desplazamiento */
      }
      .cont-combo-visible-sin-opciones {
            border-radius: 50px;
            /* background-color: blue; */
      }
      .cont-combo {
            position: relative;
            width: 100%;
      }
      .cont-cruz-unselect {
            position: absolute;
            right: 0px;
            bottom: 0px;
            height: 50px;
            width: 50px;
            z-index: 99;
      }
      .cont-real-combo {
            /* border: solid 1px grey; */
            /* border-radius: 50px; */
      }
      .real-combo {
            font-size: 16px;
            /* font-family: "Roboto", sans-serif; */
            outline: none;
            border-radius: 50px;
            padding: 12px;
            outline: none;
            box-shadow: none;
            padding-left: 50px;
      }
      .real-combo:focus {
            border-color: #7f56da;
            outline: none;
            box-shadow: none;
      }
      .opcion-item {
            border-bottom: solid 1px grey;
            padding: 15px;
            cursor: pointer;
      }
      .opcion-item-selected {
            background-color: #7f56da;
            color: white;
      }
      .label-input {
            position: absolute;
            left: 50px;
            top: 10px;
            font-size: 16px;
            color: #5f5f5f;
            transition:
                  top 0.2s ease,
                  font-size 0.2s ease,
                  color 0.2s ease;
            cursor: text;
            padding-left: 4px;
            padding-right: 4px;
            padding-top: 2px;
            padding-bottom: 2px;
      }

      .label-input.floated {
            top: -10px;
            left: 30px;
            font-size: 14px;
            color: #7f56da;
            background-color: white;
            padding: 0 5px;
            border-radius: 4px;
      }

      .input {
            border: 1px solid #c3c3c3;
            border-radius: 4px;
            font-size: 16px;
            outline: none;
            transition: border-color 0.2s;
            padding: 16px 12px;
            width: 100%;
            background-color: transparent;
            font-size: 16px;
            /* font-family: "Roboto", sans-serif; */
            outline: none;
      }

      .input:focus {
            border-color: #7f56da;
      }
      .cont-img-option {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            margin-right: 15px;
      }
      .img-selected {
            width: 30px;
            height: 30px;
            background-color: lightgrey;
            position: absolute;
            left: 10px;
            top: 10px;
            border-radius: 50%;
      }
</style>
